import React, { useEffect, useState, useContext, } from 'react';
import { Collapse, Layout, Row, Space, Button, Form, Typography, Result, } from 'antd';
import { EditOutlined, SaveOutlined, } from '@ant-design/icons';
import { StationHeader } from '../StationHeader/StationHeader.component';
import { EditStationInformationForm } from './EditStationInformationForm.component';
import { StationInformationCard } from './StationInformationCard.component';
import { DevicesList } from '../Devices/DevicesList/DevicesList.component';
import { StationContext } from '../../../../context/station-context';
import { NocItemContext } from '../../../../context/noc-item-context';
import { useApp } from '../../../../context/app-context';
import { StationProfile } from './StationProfile';
import { Restricted } from '../../../UI/Restricted.component';
import { PermissionsContext } from '../../../../router/DashboardRoutes';

const { Text } = Typography;
const { Panel } = Collapse;
const { Content } = Layout;

export const Station = ({pendingState, anthemProfiles, setPendingState, setUpdateAllPendingChanges, setPendingChangesModal, pendingChangesModal, updateAllPendingChanges, refresh, ...props}) => {

    const { state: {user}} = useApp();
    
    const userPermissions = useContext(PermissionsContext);
    const isPCI = userPermissions.server.pci;

    const [nocItem, dispatchNocItem] = useContext(NocItemContext);
    const [stationState, stationDispatch] = useContext(StationContext);
    const [displayEditStationForm, setDisplayEditStationForm] = useState(false);
    const [activeKeys, setActiveKeys] = useState(['1', '3']);

    // Station Profile Selection 
    const [displayEditProfileForm, setDisplayEditProfileForm] = useState(false);
    const [profileSettingsDevicesList, setProfileSettingsDevicesList] = useState([]);

    const [form] = Form.useForm();
    const station = stationState.station;

    useEffect(() => {
        dispatchNocItem({
            type: 'UPDATE_STATION', 
            payload: station,
        })
    }, [station, stationDispatch])

    useEffect(() => {
        // Reset forms on station change
        setDisplayEditStationForm(false);
        setDisplayEditProfileForm(false);
    }, [station])

    useEffect(() => {
        if(displayEditStationForm){
            form.resetFields();
        }
    }, [displayEditStationForm, form])

    const cancelBtnHandler = () => {
        toggleEditInformationForm();
    };

    const toggleEditInformationForm = () => {
        setDisplayEditStationForm(!displayEditStationForm);
    }

    const getDevicesCount = () => {
        let count = 0;
        if(station){
            if(station.Devices)
                count += station.Devices.length 
            if (station.MacDevices){
                count += station.macDevices.length;
            }
        }
        return count;
    }

    const extra = (
        <Restricted to='station.edit'>
            <Row justify="end" className="btn-group__extra">
                <Space size="small"> 
                    { !displayEditStationForm ? 
                        <Button type="primary" onClick={() => toggleEditInformationForm()} icon={<EditOutlined/>}>Edit</Button>
                    :
                        <>
                            <Button onClick={cancelBtnHandler}>Cancel</Button>
                            <Button htmlType='submit' form={`station-${station?.id}-information-form`} type="primary" icon={<SaveOutlined/>}>Save</Button>
                        </>
                    }
                </Space>
            </Row>
        </Restricted>
    );

    const profileSelectionExtra = (
        <Restricted to='stationProfile.edit'>
            <Row justify="end" className="btn-group__extra">
                <Space size="small"> 
                        <Button type="primary" onClick={() => setDisplayEditProfileForm(true)} icon={<EditOutlined/>}>Edit</Button>
                </Space>  
            </Row>
        </Restricted>
    )

    const totalDevices = <span>List of Devices <Text type="secondary">({getDevicesCount()} Results)</Text></span>

    const stationCollapseItems = [
        {
            className: "station__collapse__panel", 
            label: "Station Information", 
            key: (user?.settings?.siteExpandable) ? "1" : "0",
            extra: activeKeys?.includes(user?.settings?.siteExpandable ? "1" : "0") && extra, 
            collapsible: "header", 
            children: displayEditStationForm ? 
                    <Restricted to='station.edit'>
                        <EditStationInformationForm form={form}/>
                    </Restricted>
                : 
                    <StationInformationCard/>
        }, 
        ...((isPCI && profileSettingsDevicesList?.length > 0) ? 
            [{
                className: "station__collapse__panel", 
                label: 'Station Profile', 
                key: '2', 
                extra: activeKeys?.includes('2') && profileSelectionExtra, 
                collapsible: 'header', 
                children: (
                    <Restricted to='server.pci'>
                        <StationProfile 
                            displayEditProfileForm={displayEditProfileForm} 
                            setDisplayEditProfileForm={setDisplayEditProfileForm} 
                            dataSource={profileSettingsDevicesList}
                        />
                    </Restricted>
                )
            }] : []), 
        { 
            className: "station__collapse__panel", 
            label: totalDevices, 
            key: "3", 
            children: (
                <DevicesList
                    anthemProfiles={nocItem.anthemProfiles}
                    pendingState={pendingState}
                    setPendingState={setPendingState}
                    pendingChangesModal={pendingChangesModal}
                    setPendingChangesModal={setPendingChangesModal}
                    updateAllPendingChanges={updateAllPendingChanges}
                    setUpdateAllPendingChanges={setUpdateAllPendingChanges}
                    refresh={refresh}
                    setProfileSettingsDevicesList={setProfileSettingsDevicesList}
                />
            )
        }
    ]

    const collapseHandleChange = (keys) => {
        setActiveKeys(keys);
    }

    return <>
        {nocItem && nocItem?.stationList?.length > 0 ? 
            <Layout className='layout'>
                { station && 
                    <div id={`station-${station?.id}`}>
                        <StationHeader 
                            pendingState={pendingState} 
                            setPendingState={setPendingState} 
                            setUpdateAllPendingChanges={setUpdateAllPendingChanges}
                            baseDevices={profileSettingsDevicesList}
                        />
                        <Content className="station__content">
                            <div>
                                <Collapse
                                    ghost
                                    defaultActiveKey={['1', '3']}
                                    className="station__collapse"
                                    items={stationCollapseItems}
                                    onChange={collapseHandleChange}
                                    activeKey={activeKeys}
                                />
                            </div>
                        </Content>
                    </div>
                }
            </Layout>
            :
            <Layout className='layout'>
                <Result
                    title='No stations to display'
                    subTitle="Sorry, we couldn't find any results."
                />
            </Layout>                
        }
    </>
}